import {useFSMStore} from 'stores/useFSMStore';
import {useEffect} from 'react';
import {useSceneStore} from 'stores/useSceneStore';
import {logHelper, tLogStyled} from 'utils/Logger';
import {useRenderStore} from 'stores/useRenderStore';
import {LoopOnce, LoopRepeat} from 'three/src/constants';

export const useHandleAnimations = (): void => {
  const currentFSMState = useFSMStore(state => state.currentFSMState);
  const actions = useSceneStore(state => state.actions);
  const isIdle = useRenderStore(state => state.isIdle);

  useEffect(() => {
    if (currentFSMState) {

      const actionShouldLoop = (state: string) => state.slice(-1) === '*';

      const hasExactMatch = (validStates: string) => validStates
        .split('&') // split multiple valid states
        .map(validState => actionShouldLoop(validState) ? validState.slice(0, -1) : validState) // remove last char if * is added for looping
        .some(validState => validState === currentFSMState); // check if currentState is a valid state

      const isValidRecursive = (validStates: string, currentFSMState: string): boolean => {
        if (!validStates || !currentFSMState) return false;

        if (hasExactMatch(validStates)) return true;

        else {
          const parent = currentFSMState.split('.').slice(0, -1); // remove last element
          if (parent.length > 0) return isValidRecursive(validStates, parent.join('.'));
        }
        return false;
      };


      Object.keys(actions)
        .filter(key => !!actions[key])
        .forEach(key => {
          if (isValidRecursive(key, currentFSMState)) {
            if (actionShouldLoop(key)) {
              actions[key]!.loop = LoopRepeat;
              actions[key]!.clampWhenFinished = false;
            }else {
              actions[key]!.loop = LoopOnce;
              actions[key]!.clampWhenFinished = true;
            }
            actions[key]!.play();
            // actions[key]!.timeScale = 0.25;
            tLogStyled(`[useHandleAnimations] Play action ${key}`, logHelper.start); // DEBUG
          } else {
            actions[key]?.stop();
            tLogStyled(`[useHandleAnimations] Stop action ${key}`, logHelper.stop); // DEBUG
          }
        });
    }
  }, [currentFSMState, actions]);

  useEffect(() => {
    Object.keys(actions).filter(key => !!actions[key]).forEach(key => {
      actions[key]!.timeScale = isIdle ? 0 : 1;
    });
  }, [actions, isIdle]);
};
